module.exports = __webpack_public_path__ + "static/logo_w-425824134c87a8d6a700729f022a05dd.svg";